exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TopHeader{width:100%}.TopHeader.start{background:var(--gray-0)}.TopHeader.end{background:var(--tools-header-background)}.TopHeader.closed{padding:0;display:none}.TopHeader.stroke{border-bottom:1px solid var(--gray-4)}.TopHeader:first-child{z-index:73}", ""]);

// exports
